<template>
    <layout title="Board Settings">
        <settings-layout>
            <div class="px-8">
                <div v-if="saving" class="animate-pulse rounded-md bg-blue-50 p-4 mb-4">
                    <div class="flex items-center justify-center">
                        <p class="text-sm text-blue-700">
                            Uploading...
                        </p>
                    </div>
                </div>
                <ul class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-2">
                    <li class="col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200">
                        <div class="w-full flex items-center text-center justify-center p-6 pb-10 space-x-6">
                            <h3 class="text-gray-900 text-xl font-medium">Board Meeting Dates</h3>
                        </div>
                        <div>
                            <div class="-mt-px flex divide-x divide-gray-200">
                                <div class="w-0 flex-1 flex">
                                    <a :href="`/storage/board-meeting-dates.pdf?${Date.now()}`" target="_blank" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                                        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>
                                        <span class="ml-3">View Current</span>
                                    </a>
                                </div>
                                <div class="-ml-px w-0 flex-1 flex">
                                    <label class="cursor-pointer w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500">
                                        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path></svg>
                                        <span class="ml-3">Upload New</span>
                                        <input accept=".pdf" @change="onBoardMeetingDates" ref="boardMeetingDates" class="hidden" type="file" name="boardMeetingDates">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200">
                        <div class="w-full items-center text-center p-6 pb-5 space-x-6">
                            <h3 class="text-gray-900 text-xl font-medium">Board Notes Password</h3>
                            <p class="text-xs">https://app.pycoindustries.com/board-notes</p>
                        </div>
                        <div>
                            <board-notes-password :password="password"></board-notes-password>
                        </div>
                    </li>
                </ul>
            </div>
        </settings-layout>
    </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import SettingsLayout from "./SettingsLayout";
import BoardNotesPassword from "@/Components/BoardNotes/BoardNotesPassword";

export default {
    components: {BoardNotesPassword, SettingsLayout, Layout },
    metaInfo() {
        return {
            title: `Settings`,
        }
    },
    props: {
        password: {
            type: Object,
        }
    },
    data() {
        return {
            saving: false,
            success: false,
        }
    },
    methods: {
        onBoardMeetingDates() {
            let data = new FormData()
            data.append('type', 'current')
            data.append('file', this.$refs.boardMeetingDates.files[0])
            this.upload(data)
        },
        upload(data) {
            this.$inertia.post(this.route('settings.board-settings.store-dates'), data,
                {
                    onStart: () => this.saving = true,
                    onFinish: () => this.saving = false,
                    onSuccess: () => this.success = true
                }
            )
        }
    }
}
</script>
